import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import Spacing from '../Spacing';

export default function ColumnChart({ patientEncounterCountMonthWise }) {

  const [chartData, setChartData] = useState({ series: [], options: {} });

  useEffect(() => {
    if (patientEncounterCountMonthWise?.length > 0) {
      const seriesData = patientEncounterCountMonthWise.map(item => item.patient_encounter_count);
      const categoriesData = patientEncounterCountMonthWise.map(item => item.month_name);
      const yearData = patientEncounterCountMonthWise.map(item => item.year);

      const newOptions = {
        chart: {
          height: 350,
          type: 'bar',
          toolbar: {
            show: false,
          },
        },
        colors: ['#5EB0EF'],
        plotOptions: {
          bar: {
            columnWidth: '80%',
            distributed: false,
            borderRadius: 2,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: categoriesData?.map((month) => month?.substring(0, 3)),
          labels: {
            style: {
              colors: '#817F8B',
              fontSize: '12px',
            },
          },
        },
        tooltip: {
          x: {
            formatter: function (value, { dataPointIndex }) {
              return categoriesData[dataPointIndex]+' - '+yearData[dataPointIndex];
            },
          },
        },
      };

      setChartData({ series: [{ data: seriesData ,name:"Patient Encounter"}], options: newOptions });
    }
  }, [patientEncounterCountMonthWise]);

  return (
    <div className="docpro_chart">
      {patientEncounterCountMonthWise?.length > 0 ? (
        <ReactApexChart
          options={chartData?.options}
          series={chartData?.series}
          type="bar"
          height={300}
        />
      ) : (
        <Spacing lg="20" sm="20" />
      )}
    </div>
  );
}
